import { useMutation } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
export const useTelegramLinkCode = () => useMutation({
    mutationFn: async () => {
        const { data } = await apiClient.post('/telegram/link-code');
        return data;
    },
});
